import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { changeFavicon, getInstitutionFromPath } from '../utils/faviconUtils';

// Custom hook to handle favicon changes based on route
export const useDynamicFavicon = () => {
  const location = useLocation();
  
  useEffect(() => {
    const institution = getInstitutionFromPath(location.pathname);
    changeFavicon(institution);
  }, [location.pathname]);
};
